<template>
	<section class="gallery-section">
		<div v-if="header" class="row row-header align-center">
			<h2>{{ header }}</h2>
		</div>
		<div class="row items flex-row">
			<div class="columns column12">
				<div v-if="items.images.length" class="gallery-wrapper flex-row">
					<masonry :cols="{ default: 3, 1280: 2, 960: 1 }" :gutter="0" class="masonry">
						<div v-for="item in items.images" :key="item.ID" class="columns">
							<div class="fade-animate">
								<div class="image-overlay" />
								<picture>
									<source :srcset="item.imagesWebp[1]" type="image/webp" media="(max-width: 960px)" />
									<source
										:srcset="item.imagesWebp[2]"
										type="image/webp"
										media="(max-width: 1700px)"
									/>
									<source
										:srcset="item.imagesWebp[1]"
										type="image/webp"
										media="(max-width: 3000px)"
									/>
									<source :srcset="item.imagesWebp[0]" />
									<source :srcset="item.images[1]" media="(max-width: 960px)" />
									<source :srcset="item.images[2]" media="(max-width: 1700px)" />
									<source :srcset="item.images[1]" media="(max-width: 3000px)" />
									<source :srcset="item.images[0]" />
									<img :src="item.image" :alt="item.imageAlt" loading="lazy" />
								</picture>
							</div>
						</div>
					</masonry>
				</div>
			</div>
		</div>
		<div v-if="content" class="content-row row">
			<div class="columns column12 align-center">
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	items: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.masonry {
	width: 100%;

	> div {
		.columns {
			padding: 0 0 30px;
			width: 100%;

			img {
				width: 100%;
			}
		}

		&:first-child {
			.columns {
				padding: 0 30px 30px 0;
			}
		}

		&:last-child {
			.columns {
				padding: 0 0 30px 30px;
			}
		}
	}
}

.content-row {
	margin: 60px auto 0;

	p,
	:deep(p) {
		margin: 0;

		a {
			margin: 0;
		}
	}
}

.gallery-section {
	padding: 120px 0 80px;
	background: var(--primary-background-color);

	.row-header {
		margin: 0 auto 30px;
		justify-content: center;
	}
}

.flex-row {
	.flex-row {
		gap: 0;
	}
}

@media (max-width: 1300px) {
	.masonry-wall {
		.masonry-column {
			.columns {
				padding: 15px !important;
			}
		}
	}
}

@media (max-width: 1080px) {
	.gallery-section {
		.row-header {
			h2 {
				font-size: 60px;
				line-height: 65px;
			}
		}
	}
}

@media (max-width: 960px) {
	.masonry > div:last-child .columns {
		padding-left: 0;
	}

	.gallery-section {
		padding: 120px 0 60px;
	}
}

@media (max-width: 920px) {
	.gallery-section {
		.row-header {
			h2 {
				font-size: 40px;
				line-height: normal;
			}
		}
	}
}

@media (max-width: 680px) {
	.gallery-section {
		.row-header {
			margin: 0 auto;
		}
	}
}
</style>
